import { useBjelinTranslations } from "../../../hooks/TranslationHooks";

const FieldRequired = () => {
  const t = useBjelinTranslations();
  return (
    <span className={"text-danger"} title={t("required.field")}>
      {"*"}
    </span>
  );
};

export default FieldRequired;
